'use client';

import { motion, useAnimationControls } from 'framer-motion';
import cx from 'classnames';

interface JumbotronProps {
    className?: string;
    children: React.ReactNode;
}

const Jumbotron = ({ className = '', children }: JumbotronProps) => {
    const controls = useAnimationControls();

    return (
        <motion.header className={cx('relative w-full flex select-none', {
            'bg-white': ! className.includes('bg-'),
            'items-center': ! className.includes('items-'),
            'h-screen': ! className || ! className.includes('h-'),
            [className]: Boolean(className)
        })} animate={controls}>
            {children}
        </motion.header>
    );
};

export { Jumbotron };